import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Pagination, Searchbox, LoadingOverlay } from 'components'
import { productActions } from 'redux/actionCreators'
import classes from './AdminProduct.scss'
import { Link } from 'react-router'

// Lodash
import _isNil from 'lodash.isnil'
import _get from 'lodash.get'
import _omitBy from 'lodash.omitby'
import { hasChanged } from 'helpers/utilities'

@connect(state => ({
  products: _get(state, ['product', 'products']) || [],
  pageCount: _get(state, ['product', 'pageCount']) || 0,
  importing: _get(state, 'product.importAttempting') || false,
  configsImporting: _get(state, 'product.importConfigsAttempting') || false,
  stocksImporting: _get(state, 'product.importStocksAttempting') || false,
  bisImporting: _get(state, 'product.importBisAttempting') || false,
  fdImporting: _get(state, 'product.importFdAttempting') || false
}), dispatch => ({
  attemptFindAllProducts: (payload) =>
    dispatch(productActions.attemptFindAllProducts({
      ...payload,
      limit: 100
    })),
  attemptImportProducts: (payload) =>
    dispatch(productActions.attemptImportProducts(payload)),
  attemptImportConfigs: (payload) =>
    dispatch(productActions.attemptImportConfigs(payload)),
  attemptImportStocks: (payload) =>
    dispatch(productActions.attemptImportStocks(payload)),
  attemptImportBackInStock: (payload) =>
    dispatch(productActions.attemptImportBackInStock(payload)),
  attemptImportFreeDelivery: (payload) =>
    dispatch(productActions.attemptImportFreeDelivery(payload)),
  setInitial: () =>
    dispatch({ type: 'SET_INITIAL' })
}))
class AdminProducts extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  _renderRow = ({ productCode, unit, unitId, productName, retail, wholesale1, wholesale2, wholesale3, wholesale4 }) =>
    <tr key={`${productCode}-${unitId}`}>
      <td className='text-center'>{productCode}</td>
      <td className='text-center'>{productName}</td>
      <td className='text-center'>{unit}</td>
      <td className='text-right'>{retail}</td>
      <td className='text-right'>{wholesale1}</td>
      <td className='text-right'>{wholesale2}</td>
      <td className='text-right'>{wholesale3}</td>
      <td className='text-right'>{wholesale4}</td>
      <td className='text-center'>
        <img src='/images/icon-pencil-orange.png'
          alt='icon-pencil-orange'
          onClick={() => this.context.router.push(`/admin/products/${productCode}?unitId=${unitId}`)} />
      </td>
    </tr>

  _renderMobileRow = ({ productCode, unitId, unit, productName, retail, wholesale1, wholesale2, wholesale3, wholesale4 }) =>
    <div key={`${productCode}-${unitId}`} className='row'>
      <Link to={`/admin/products/${productCode}`}>
        <div className='line'>
          <strong>รหัสสินค้า</strong>
          <span>{productCode}</span>
        </div>
        <div className='line'>
          <strong>ชื่อสินค้า</strong>
          <span>{productName || '-'}</span>
        </div>
        <div className='line'>
          <strong>หน่วยสินค้า</strong>
          <span>{unit || '-'}</span>
        </div>
        <div className='line'>
          <strong>ราคาปลีก</strong>
          <span>{retail || '-'} บาท</span>
        </div>
        <div className='line'>
          <strong>ราคาส่งระดับ 1</strong>
          <span>{wholesale1 || '-'} บาท</span>
        </div>
        <div className='line'>
          <strong>ราคาส่งระดับ 2</strong>
          <span>{wholesale2 || '-'} บาท</span>
        </div>
        <div className='line'>
          <strong>ราคาส่งระดับ 3</strong>
          <span>{wholesale3 || '-'} บาท</span>
        </div>
        <div className='line'>
          <strong>ราคาส่งระดับ 4</strong>
          <span>{wholesale4 || '-'} บาท</span>
        </div>
      </Link>
      <img className='rowArrow' src='/images/icon-arrow-right.png' alt='icon-arrow-right' />
    </div>

  componentWillMount () {
    this._findProducts(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (hasChanged(this.props, nextProps, ['location', 'query'])) {
      this._findProducts(nextProps)
    }
  }

  _findProducts = (props) => {
    const query = _get(props, ['location', 'query']) || {}

    this.props.attemptFindAllProducts(_omitBy({
      offset: (parseInt(query.page || 1, 10) - 1) * 100,
      barcode: query.keyword || undefined,
      productCode: query.keyword || undefined,
      productName: query.keyword || undefined,
      company: query.keyword || undefined,
      genericName: query.keyword || undefined
    }, _isNil))
  }

  _onSearch = (keyword) => {
    this.context.router.replace(`${this.props.location.pathname}?keyword=${keyword}`)
  }

  _onAdd = () => {
    this.context.router.push('/admin/products/new')
  }

  _onImportConfigs = () => this.refs.configFileChooser.click()
  _onConfigFileChosen = (e) => {
    this.props.attemptImportConfigs(e.target.files[0])
    e.target.files = null
  }

  _onImportStocks = () => this.refs.stockFileChooser.click()
  _onStockFileChosen = (e) => {
    this.props.attemptImportStocks(e.target.files[0])
    e.target.files = null
  }

  _onImportBackInStock = () => this.refs.bisFileChooser.click()
  _onBISFileChosen = (e) => {
    this.props.attemptImportBackInStock(e.target.files[0])
    e.target.files = null
  }

  _onImportFreeDelivery = () => this.refs.fdFileChooser.click()
  _onFDFileChosen = (e) => {
    this.props.attemptImportFreeDelivery(e.target.files[0])
    e.target.files = null
  }

  render () {
    const { products, pageCount, location } = this.props
    return (
      <section className={classes.products}>
        <div className={`search-box ${classes.searchbox}`}>
          <Searchbox keyword={_get(location, ['query', 'keyword'])} onSearch={this._onSearch}
            description='ค้นหาสินค้าได้จาก Barcode, รหัสสินค้า, Generic Name, ชื่อสินค้า, ชื่อบริษัท' />
        </div>
        <div className='relative'>
          <Pagination router={this.context.router} location={location} pageCount={pageCount} />
          <div className='buttons'>
            <div className='btn btn-orange' onClick={this._onImportConfigs}>
              <input
                type='file'
                ref='configFileChooser'
                onChange={this._onConfigFileChosen}
                style={{ display: 'none' }} />
              <span>นำเข้าข้อมูลสินค้า</span>
            </div>
            <div className='btn btn-blue' onClick={this._onImportBackInStock}>
              <input
                type='file'
                ref='bisFileChooser'
                onChange={this._onBISFileChosen}
                style={{ display: 'none' }} />
              <span>นำเข้าสินค้า Back in stock</span>
            </div>
            <div className='btn btn-blue' onClick={this._onImportFreeDelivery}>
              <input
                type='file'
                ref='fdFileChooser'
                onChange={this._onFDFileChosen}
                style={{ display: 'none' }} />
              <span>นำเข้าสินค้าส่งฟรี</span>
            </div>
            {/*
              <div className='btn btn-blue' onClick={this._onImportStocks}>
                <input
                  type='file'
                  ref='stockFileChooser'
                  onChange={this._onStockFileChosen}
                  style={{ display: 'none' }} />
                <span>นำเข้าสต็อกสินค้า</span>
              </div>
            */}
          </div>
        </div>
        <table className='with-stripe desktop'>
          <thead>
            <tr>
              <td rowSpan='2'>รหัสสินค้า</td>
              <td rowSpan='2'>ชื่อสินค้า</td>
              <td rowSpan='2'>หน่วย</td>
              <td colSpan='5'>ราคา</td>
              <td rowSpan='2'>แก้ไข</td>
            </tr>
            <tr>
              <td>ปลีก</td>
              <td>ส่งระดับ 1</td>
              <td>ส่งระดับ 2</td>
              <td>ส่งระดับ 3</td>
              <td>ส่งระดับ 4</td>
            </tr>
          </thead>
          <tbody>{products.map(this._renderRow)}</tbody>
          {!products.length && <tr><td className='text-center' colSpan='11'>ยังไม่มีรายการสินค้า</td></tr>}
        </table>
        <section className='list'>
          {products.map(this._renderMobileRow)}
        </section>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
        {(this.props.configsImporting || this.props.stocksImporting || this.props.bisImporting || this.props.fdImporting) && <LoadingOverlay />}
      </section>
    )
  }
}

export default AdminProducts



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminProduct/AdminProducts.js